import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import {
	formatWorkerChangeWorkPlaceDetail,
	formatWorkerChangeWorkPlaceExcelList,
	formatWorkerChangeWorkPlaceList,
} from './worker-change-work-place.helper';
import { WorkerChangeWorkPlaceActions } from './worker-change-work-place.redux';
import {
	IPayloadCreateWorkerChangeWorkPlaceRequest,
	IPayloadDeleteWorkerChangeWorkPlaceRequest,
	IPayloadGetWorkerChangeWorkPlaceDetailRequest,
	IPayloadGetWorkerChangeWorkPlaceExcelListRequest,
	IPayloadGetWorkerChangeWorkPlaceListRequest,
} from './worker-change-work-place.type';

export function* getWorkerChangeWorkPlaceListSaga(
	action: PayloadAction<IPayloadGetWorkerChangeWorkPlaceListRequest>
) {
	const { callback, ...rest } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetWorkerChangeWorkPlaceListResponse> =
			yield API.getWorkerChangeWorkPlaceList({ ...rest });

		const content = formatWorkerChangeWorkPlaceList(res?.data?.content);
		yield put(
			WorkerChangeWorkPlaceActions.getWorkerChangeWorkPlaceListSuccess({
				...rest,
				content,
				total: res?.data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			WorkerChangeWorkPlaceActions.getWorkerChangeWorkPlaceListFailure()
		);
	}
}

export function* getWorkerChangeWorkPlaceExcelListSaga(
	action: PayloadAction<IPayloadGetWorkerChangeWorkPlaceExcelListRequest>
) {
	const { callback, ...rest } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetWorkerChangeWorkPlaceListResponse> =
			yield API.getWorkerChangeWorkPlaceList({ ...rest });

		const content = formatWorkerChangeWorkPlaceExcelList(res?.data?.content);
		yield put(
			WorkerChangeWorkPlaceActions.getWorkerChangeWorkPlaceExcelListSuccess()
		);
		callback?.({ data: content });
	} catch (error) {
		callback?.({ error });
		yield put(
			WorkerChangeWorkPlaceActions.getWorkerChangeWorkPlaceExcelListFailure()
		);
	}
}

export function* deleteWorkerChangeWorkPlace(
	action: PayloadAction<IPayloadDeleteWorkerChangeWorkPlaceRequest>
) {
	const { callback, ids } = action.payload;

	try {
		yield API.deleteWorkerChangeWorkPlace(ids);

		yield put(
			WorkerChangeWorkPlaceActions.deleteWorkerChangeWorkPlaceSuccess()
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			WorkerChangeWorkPlaceActions.deleteWorkerChangeWorkPlaceFailure()
		);
	}
}

export function* createWorkerChangeWorkPlace(
	action: PayloadAction<IPayloadCreateWorkerChangeWorkPlaceRequest>
) {
	const { callback, data } = action.payload;

	try {
		yield API.createWorkerChangeWorkPlace(data);

		yield put(
			WorkerChangeWorkPlaceActions.createWorkerChangeWorkPlaceSuccess()
		);
		callback?.();
	} catch (error: unknown) {
		callback?.(error as API.ApiResponseError);
		yield put(
			WorkerChangeWorkPlaceActions.createWorkerChangeWorkPlaceFailure()
		);
	}
}

export function* getWorkerChangeWorkPlaceDetail(
	action: PayloadAction<IPayloadGetWorkerChangeWorkPlaceDetailRequest>
) {
	const { id, callback } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.IWorkerChangeWorkPlaceDetail> =
			yield API.getWorkerChangeWorkPlaceDetail(id);

		const workerChangeWorkPlaceDetail = formatWorkerChangeWorkPlaceDetail(
			res.data
		);

		yield put(
			WorkerChangeWorkPlaceActions.getWorkerChangeWorkPlaceDetailSuccess({
				workerChangeWorkPlaceDetail,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			WorkerChangeWorkPlaceActions.getWorkerChangeWorkPlaceDetailFailure()
		);
	}
}
